import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { AdminFormRow } from "./types";

// GET /api/admin/forms/:id — full FormRow including definition + workflow +
// automation + is_system flag.
//
// Phase 7 sub-bucket 11. The builder page's single source of truth; the
// per-field hooks (useAddField / useUpdateField / useRemoveField /
// useReorderFields) do optimistic cache writes against this key so the
// canvas re-renders from cache without a local mirror.
export function useForm(id: string | undefined) {
  return useQuery<AdminFormRow, ApiClientError>({
    queryKey: id ? queryKeys.adminForms.detail(id) : ["admin-forms", "detail", "__missing__"],
    queryFn: () => apiFetch<AdminFormRow>(`/admin/forms/${id}`),
    enabled: !!id,
  });
}
